import { useEffect } from 'react';
import type { Calendars } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useCalendars() {
  const auctions = useAxios(
    (axios, baseConfig) =>
      axios.request<Calendars>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/auctions/calendars`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    auctions.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return auctions;
}

export type CalendarsRequest = ReturnType<typeof useCalendars>;
